import axios from "axios";
import { baseDomain } from "../../../../../Constants/apiRoutes";

// Base URL for Recorded Videos (Using absolute path to ensuring V1 as per initial req, though axios might have base)
// The user provided https://api-uat.nispand.com/v1/recordedVideos in first request.
const BASE_URL_V1 = `${baseDomain}/v1`;
const BASE_URL_V2 = `${baseDomain}/v2`;

export const createRecordedVideoApi = (data) => {
  return axios.post(`${BASE_URL_V2}/recordedVideos`, data);
};

export const updateRecordedVideoApi = (id, data) => {
  return axios.put(`${BASE_URL_V2}/recordedVideos/${id}`, data);
};

export const getRecordedVideoApi = (id) => {
  return axios.get(`${BASE_URL_V2}/recordedVideos/${id}`);
};

export const getAllRecordedVideosApi = (page = 1, limit = 10) => {
  return axios.get(`${BASE_URL_V2}/recordedVideos?page=${page}&limit=${limit}`);
};

export const getRecordedVideoBinApi = (page = 1, limit = 10) => {
  return axios.get(`${BASE_URL_V2}/recordedVideos/bin/list?page=${page}&limit=${limit}`);
};

export const deleteRecordedVideoApi = (id) => {
  return axios.delete(`${BASE_URL_V2}/recordedVideos/${id}`);
};

export const restoreRecordedVideoApi = (id) => {
  return axios.put(`${BASE_URL_V2}/recordedVideos/restore/${id}`);
};

// New API for Dropdown
export const getAllLiveSessions = ({ page, limit }) => {
  return axios.get(`${BASE_URL_V2}/liveSession?isLive=true&page=${page}&limit=${limit}`);
};
